module.exports = __webpack_public_path__ + "img/banner1.acaa63d8.png";